import { BaseError, type BaseErrorParameters } from './base';

export class InvalidExternalAuthError extends BaseError {
  constructor({ cause }: Pick<BaseErrorParameters, 'cause'>) {
    super({
      cause,
      code: 'invalid_external_auth_error',
      docsUrl:
        'https://www.dynamic.xyz/docs/external-auth/third-party-auth-overview',
      name: 'InvalidExternalAuthError',
      shortMessage: 'Error authenticating with external JWT',
    });
  }
}
